import type { PoolPricingConfig } from '@thinkalpha/ui-types/types/admin/lab-pool-pricing';

/**
 * Seed config for the pricing editor (PLAT-12937) when a pool has no
 * pricing configured yet. Uses the hierarchy order from the spec example;
 * the minimum-price input is left absent until an admin enables it.
 */
export const DEFAULT_POOL_PRICING_CONFIG = {
    hierarchy: ['fair-value', 'reference', 'cached', 'admin'],
} satisfies PoolPricingConfig;
